import { render } from "./CountryComponent.vue?vue&type=template&id=f23f3c68"
import script from "./CountryComponent.vue?vue&type=script&lang=js"
export * from "./CountryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__